<template>
  <div class="ranking-list">
    <!-- 类型是日的情况 -->
    <div v-if="type == 1" v-for="(l,i) in list" :key="l.area_id" @click="clickCity(l)" class="ranking-list-item">
      <img v-if="i === 0" class="list-img" src="../../../assets/app/gold.png" alt="">
      <img v-if="i === 1" class="list-img" src="../../../assets/app/silver.png" alt="">
      <img v-if="i === 2" class="list-img" src="../../../assets/app/copper.png" alt="">
      <div v-if="i >= 3" class="list-index">{{i + 1}}</div>
      <div class="city">{{l.area_name}}</div>
      <div v-if="type == 1" class="ranking-list-item-rate">{{ vdRealVal(l) + '%'}}</div>
      <div v-if="i === 0" class="mt-progress-progress-1">
        <mt-progress :value="vdVal(l)" :bar-height="5"></mt-progress>
      </div>
      <div v-if="i === 1" class="mt-progress-progress-2">
        <mt-progress :value="vdVal(l)" :bar-height="5"></mt-progress>
      </div>
      <div v-if="i === 2" class="mt-progress-progress-3">
        <mt-progress :value="vdVal(l)" :bar-height="5"></mt-progress>
      </div>
      <div v-if="i >= 3" class="mt-progress-progress-4" :style="{width: vdVal(l) + '%'}">
        <mt-progress :value="vdVal(l)" :bar-height="5"></mt-progress>
      </div>
    </div>
    <!-- 类型是月的情况 -->
    <div v-if="type == 2" v-for="(l,i) in list" :key="l.area_id" @click="clickCity(l)" class="ranking-list-item">
      <img v-if="i === 0" class="list-img" src="../../../assets/app/gold.png" alt="">
      <img v-if="i === 1" class="list-img" src="../../../assets/app/silver.png" alt="">
      <img v-if="i === 2" class="list-img" src="../../../assets/app/copper.png" alt="">
      <div v-if="i >= 3" class="list-index">{{i + 1}}</div>
      <div class="city">{{l.area_name}}</div>
      <div class="ranking-list-item-rate">{{ vdRealVal(l) + '%'}}</div>
      <div v-if="i === 0" class="mt-progress-progress-1">
        <mt-progress :value="vdVal(l)" :bar-height="5"></mt-progress>
      </div>
      <div v-if="i === 1" class="mt-progress-progress-2">
        <mt-progress :value="vdVal(l)" :bar-height="5"></mt-progress>
      </div>
      <div v-if="i === 2" class="mt-progress-progress-3">
        <mt-progress :value="vdVal(l)" :bar-height="5"></mt-progress>
      </div>
      <div v-if="i >= 3" class="mt-progress-progress-4" :style="{width: vdVal(l) + '%'}">
        <mt-progress :value="vdVal(l)" :bar-height="5"></mt-progress>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['list', 'type'],
  data() {
    return {}
  },
  mounted(){
  },
  methods: {
    clickCity(item) {
      this.$emit('change', item)
    },
    validateVal(value) {
      value = Number(value)
      return value
    },
    // 格式化要展示的长度的值
    vdRealVal(item) {
      let value = ''
      for (let i in item) {
        if (i != "area_id" && i != 'area_name' && !i.includes('_pm')) {
          value = item[i]
        }
      }
      return Number(value)
    }, 
    // 格式化要展示的长度的值
    vdVal(item) {
      let value = ''
      for (let i in item) {
        if (i != "area_id" && i != 'area_name' && !i.includes('_pm')) {
          if(item[i] >= 100){
            value = 100
          }else if(item[i] < 0){
            value = 0
          }else{
            value = item[i]
          }
          
        }
      }
      return Number(value)
    }
  }
}

</script>
<style lang="less">
@main-color: #43484D;

.ranking-list {
  min-height: 1rem;
  background-color: #EBF1FE;
  padding: 0 0.6rem;
  padding-top: 0.2rem;
  padding-bottom: 0.3rem;
  .ranking-list-item {
    position: relative;
    height: 0.5rem;
    padding-left: 0.8rem;
    padding-top: 0.3rem;
    .list-img {
      position: absolute;
      left: 0.1rem;
      top: 0.2rem;
      width: 0.4rem;
    }
    .list-index {
      color: @main-color;
      position: absolute;
      left: 0.2rem;
      top: 0.26rem;
      width: 0.4rem;
      font-size: 0.26rem;
    }
    .city {
      color: @main-color;
      font-size: 0.26rem;
      position: absolute;
      top: 0.1rem;
      left: 0.9rem;
    }
    .ranking-list-item-rate {
      color: @main-color;
      font-size: 0.26rem;
      position: absolute;
      top: 0.1rem;
      right: 0%;
    }
  }
  .mt-progress-progress {
    background-color: #6985EC;
    border-radius: 0.2rem;
  }
  .mt-progress-progress-1 {
    .mt-progress-progress {
      background-color: #6985EC;
    }
  }
  .mt-progress-progress-2 {
    .mt-progress-progress {
      background-color: #69A0EC;
    }
  }
  .mt-progress-progress-3 {
    .mt-progress-progress {
      background-color: #69B0EC;
    }
  }
  .mt-progress-progress-4 {
    .mt-progress-progress {
      background-color: #D0D0D0;
    }
  }
  .mt-progress-runway {
    border-radius: 0.2rem;
    background-color: transparent;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/app/add/rankList.vue